import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { ToastComponent } from '../../shared/components/toast/toast.component';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'app-private-layout',
  imports: [RouterOutlet, SidebarComponent, TopbarComponent, ToastComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="private-shell" [class.nav-open]="layout.navOpen()">
      <!-- Menu: fixo no desktop, gaveta no celular -->
      <aside class="private-sidebar" id="app-navigation" aria-label="Navegação lateral">
        <app-sidebar />
      </aside>
      <div class="private-scrim" aria-hidden="true" (click)="layout.closeNav()"></div>

      <div class="private-main">
        <app-topbar />
        <main class="private-content">
          <router-outlet />
        </main>
      </div>

      <app-toast />
    </div>
  `,
  styles: `
    .private-shell {
      min-height: 100dvh;
      background: var(--color-background);
    }

    /* ── Celular e tablet: gaveta ────────────────────────── */
    .private-sidebar {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      z-index: 130;
      width: min(296px, 86vw);
      transform: translateX(-102%);
      visibility: hidden;
      transition: transform 220ms ease, visibility 0s linear 220ms;
    }

    .nav-open .private-sidebar {
      transform: none;
      visibility: visible;
      box-shadow: var(--shadow-lg);
      transition: transform 220ms ease;
    }

    .private-scrim {
      position: fixed;
      inset: 0;
      z-index: 125;
      background: rgba(8, 14, 26, 0.45);
      opacity: 0;
      pointer-events: none;
      transition: opacity 220ms ease;
    }

    .nav-open .private-scrim {
      opacity: 1;
      pointer-events: auto;
    }

    .private-main {
      min-width: 0;
      padding-top: calc(var(--topbar-height) + env(safe-area-inset-top, 0px));
    }

    .private-content {
      display: block;
      min-width: 0;
      padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0px));
    }

    /* ── Desktop: menu fixo ──────────────────────────────── */
    @media (min-width: 1024px) {
      .private-shell {
        padding-left: var(--sidebar-width);
      }

      .private-sidebar,
      .nav-open .private-sidebar {
        z-index: 40;
        width: var(--sidebar-width);
        transform: none;
        visibility: visible;
        box-shadow: none;
        transition: none;
      }

      .private-scrim {
        display: none;
      }

      .private-content {
        padding-bottom: 1.5rem;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .private-sidebar,
      .nav-open .private-sidebar,
      .private-scrim {
        transition: none;
      }
    }
  `,
})
export class PrivateLayoutComponent {
  protected readonly layout = inject(LayoutService);
}
